import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
    palette: {
        common: {
            black: '#202020',
            white: '#ffffff',
        },
        primary: {
            main: '#006178',
            light: '#007b97',
            dark: '#005366',
            contrastText: '#ffffff',
        },
        neutral: {
            main: '#c8c8c8',
        },
        error: {
            main: '#d22630',
            light: '#fbe9ea',
            dark: '#931b22',
            contrastText: '#ffffff',
        },
        warning: {
            main: '#ffe0b3',
            light: '#fff5e6',
            dark: '#de7900',
            contrastText: '#ffffff',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    padding: '1rem 1.25rem',
                    fontWeight: '300',
                    textTransform: 'none',
                },
                sizeLarge: {
                    fontSize:
                        window.screen.width < 310
                            ? '0.875rem'
                            : window.screen.width < 350
                            ? '1rem'
                            : window.screen.width < 405
                            ? '1.25rem'
                            : '1.5rem',
                    paddingRight:
                        window.screen.width < 430 ? '1rem' : '1.25rem',
                    justifyContent: 'flex-start',
                },
                sizeMedium: {
                    fontSize: '1.25rem',
                    justifyContent: 'center',
                },
                sizeSmall: {
                    fontSize: '1.125rem',
                },
                iconSizeMedium: {
                    '& > *:first-of-type': {
                        fontSize: '1.5rem',
                    },
                },
            },
        },
        MuiSvgIcon: {
            defaultProps: {
                color: 'primary',
                fontSize: 'medium',
            },
        },
        MuiLink: {
            defaultProps: { underline: 'none' },
            styleOverrides: {
                root: {
                    lineHeight: '1',
                    borderBottom: '3px solid #00a9d9',
                    ':hover': {
                        borderBottom: '3px solid white',
                        cursor: 'pointer',
                    },
                    ':active': {
                        outline: 'solid orange 2px',
                        borderBottom: '3px solid #00a9d9',
                    },
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontSize: '1.125rem',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    paddingLeft: 0,
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    alignSelf: 'center',
                    color: '#202020',
                    backgroundColor: '#E3EDF0',
                },
                action: {
                    paddingLeft: '0.25rem',
                },
                standard: {
                    zIndex: '2',
                },
            },
        },
        MuiImageListItem: {
            styleOverrides: {
                root: {
                    margin: '0.25rem',
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                content: {
                    '&.Mui-expanded': {
                        margin: 0,
                    },
                    margin: 0,
                },
            },
        },
    },
})
